import React from 'react';
import _ from 'lodash';
import TaskIconSelector from '@jswork/task-icon-selector';

export interface EventData {
  target: {
    value: string;
  };
}

interface Props {
  value?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (event: EventData) => void;
}

const items: Array<{
  value: string;
  url: string;
}> = _.range(1, 19).map(item => {
  const strIndex = nx.padIndex(item, { size: 1 });
  return {
    value: `IMG_${strIndex}`,
    url: `https://course-assets.alo7.com/kellis/icon/${strIndex}.png`,
  };
});

export const getImage = (inValue: string) => {
  const value = inValue || 'IMG_01';
  return items.find(item => item.value === value).url;
};

export default (props: Props): JSX.Element => {
  return <TaskIconSelector items={items} {...props} />;
};
